export default __webpack_public_path__ + "static/media/amazons3.e6bf8161.png";